import { GOOGLE_SPACING } from '../../../../../../../../const';

export const ACTIVITY_NAME_MIN_WIDTH = 24;
export const ACTIVITY_NAME_STEP = GOOGLE_SPACING * 0.9;
export const ACTIVITY_NAME_MAX_SYMBOLS_LENGTH = 15;
